var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "layout-container" } },
    [
      _c("nav-header"),
      _c("nav-module", {
        attrs: { menus: _vm.menus },
        on: { setModule: _vm.setModule },
      }),
      _c("nav-menu", {
        attrs: { menus: _vm.menus },
        on: { setMenu: _vm.setMenu },
      }),
      _c(
        "div",
        { attrs: { id: "work-container" } },
        [
          _c(
            "transition",
            { attrs: { name: "fade-transform", mode: "out-in" } },
            [_c("router-view")],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { id: "footer-container" } }, [
        _vm._v(_vm._s(_vm.config.systemCompany)),
      ]),
      _c("div", { attrs: { id: "p1" } }),
      _c("div", { attrs: { id: "p2" } }),
      _c("div", { attrs: { id: "p3" } }),
      _c("div", { attrs: { id: "p4" } }),
      _c(
        "div",
        { attrs: { id: "mtree" } },
        [
          _c("el-tree", {
            ref: "tree",
            attrs: {
              "node-key": "id",
              "empty-text": "",
              props: _vm.props,
              data: _vm.data,
              "expand-on-click-node": false,
              "default-expand-all": "",
              "highlight-current": "",
            },
            on: { "node-click": _vm.clickNode },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ node, data }) {
                  return _c("span", {}, [
                    _c("i", {
                      class: data.icon || "iconmenu el-icon-menu-default",
                    }),
                    _vm._v(" " + _vm._s(node.label) + " "),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }